<template>
<div id="Recycle-Player-pop1" class="My_popup">
  <div class="My_popup_wrap">
	<span class="My_popup_close" href="#" @click.prevent="closeClickHandler" style="cursor: pointer">닫기</span>
	<div class="My-popup-title">은평광역자원순환센터</div>
	<div class="My-popup-content green-line">
		<div class="recycle-player-wrap">
			<div class="recycle-player">
				<iframe style="display: none" src="https://www.youtube.com/embed/DnR_tEsx8wU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ref="videoA"></iframe>

				<iframe style="display: none" src="https://www.youtube.com/embed/NL35LtbAyJg" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen ref="videoB"></iframe>
			</div>
		</div>
		
	</div>
  </div>
</div>
   
</template>

<script>
export default {
	name: 'RecycleVideoWin',
	props: {
		videoType: ''
	},
    methods: {
        closeClickHandler() {
            this.$emit('close-video-win');
        }
	},
	mounted() {
		if(this.videoType === 'A') {
			this.$refs['videoA'].style.display="block"
			this.$refs['videoB'].style.display="none"
		} else {
			this.$refs['videoA'].style.display="none"
			this.$refs['videoB'].style.display="block"
		}
	}
	
}
</script>

<style scoped>

</style>
